import {ParseLinks} from './parse_links';
import {CapitalizeFirst} from './capitalize_first';
/*
import {ReplaceCharacter} from './replace_character';
import {FileSize} from './filesize';
import {SplitWords} from './split_words';
import {ReplaceStringForAol} from './replace_string_for_aol';
*/

export const MODULE_DISTRIBUTION_FILTERS = 'distribution.filters'
angular.module(MODULE_DISTRIBUTION_FILTERS, [])
  .filter('parseLinks', ParseLinks)
    .filter('capitalizeFirst', CapitalizeFirst)




/*
        .filter('replaceCharacter', ReplaceCharacter)
        .filter('filesize', FileSize)
        .filter('splitWords', SplitWords)
        .filter('replaceStringForAol', ReplaceStringForAol);
*/



// WEBPACK FOOTER //
// ./modules/distribution/filters/app.filters.module.js